import {createLink} from '@tanstack/react-router'
import {Link} from 'react-aria-components'

const RACLink = createLink(Link)

export default RACLink
